import { Icon as BPIcon } from '@blueprintjs/core'
import styled from 'styled-components'

const Icon = styled(BPIcon)`
  cursor: pointer;
`

export default Icon
